"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const partners = [{
  id: "p1",
  name: "HGTV",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_hgtv.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_hgtv.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_hgtv.png-wvc-sizes"
}, {
  id: "p2",
  name: "DIY Network",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_diy.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_diy.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_diy.png-wvc-sizes"
}, {
  id: "p3",
  name: "Pool & Spa News",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_poolspa.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_poolspa.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_poolspa.png-wvc-sizes"
}, {
  id: "p4",
  name: "Landscape Management",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_landscape.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_landscape.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_landscape.png-wvc-sizes"
}, {
  id: "p5",
  name: "Hardscape Magazine",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_hardscape.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_hardscape.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/media_logo_hardscape.png-wvc-sizes"
}];
export default function ProvenOnNationalMedia() {
  return <section data-section-id="257924" id="proven-on-national-media" className="py-16 bg-[#0B162C] text-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-10">
          <h2 className="text-2xl md:text-4xl font-bold text-white uppercase tracking-wider text-center font-default">
            Proven on National Media
          </h2>

          <div className="w-full max-w-6xl mx-auto px-8 md:px-12 relative">
            <Carousel opts={{
            align: "start",
            loop: true
          }} className="w-full">
              <CarouselContent className="items-center">
                {partners.map((partner, i) => <CarouselItem key={partner.id} data-index={i} className="basis-1/2 md:basis-1/3 lg:basis-1/5 pl-4 md:pl-8">
                    <div className="flex items-center justify-center h-24 p-4 transition-all duration-300 filter brightness-0 invert opacity-50 hover:opacity-100 cursor-pointer">
                      <img src={partner.src} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={partner.name} className="max-h-full max-w-full object-contain" loading="lazy" />
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <CarouselPrevious className="hidden md:flex -left-4 md:-left-8 bg-white/10 hover:bg-white/20 border-white/20 shadow-md text-white" />
              <CarouselNext className="hidden md:flex -right-4 md:-right-8 bg-white/10 hover:bg-white/20 border-white/20 shadow-md text-white" />
            </Carousel>
          </div>
        </div>
      </div>
    </section>;
}